import {select, fork, take, put} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';
import * as taskActionTypes from '../../tasks/taskActionTypes';

/**
 * Search service cases
 */
const searchServiceCases = function* searchServiceCases({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');
    const {searchQueryParams} = payload;

    yield put({
        type: serviceCaseActionTypes.STORE_SERVICE_CASE_SEARCH_RESULTS,
        payload: {
            serviceCaseDTOs: [],
            totalCount: 0,
            persistenceState: persistenceStates.PENDING,
            isError: false,
        },
    });

    yield fork(fetchRequest,
        serviceCaseActionTypes.SEARCH_SERVICE_CASES_REQUEST,
        leaAssignmentFlowService.getServiceCases, {
            searchQueryParams,
        });

    const searchServiceCasesResponseAction = yield take([
        serviceCaseActionTypes.SEARCH_SERVICE_CASES_REQUEST_SUCCEEDED,
        serviceCaseActionTypes.SEARCH_SERVICE_CASES_REQUEST_FAILED,
    ]);

    if (!searchServiceCasesResponseAction.error) {
        const {response} = searchServiceCasesResponseAction.payload;
        const {serviceCaseDTOs, totalCount} = response;

        yield put({
            type: serviceCaseActionTypes.STORE_SERVICE_CASE_SEARCH_RESULTS,
            payload: {
                serviceCaseDTOs,
                totalCount,
                persistenceState: persistenceStates.READY,
                isError: false,
            },
        });
    }

    if (searchServiceCasesResponseAction.error) {
        yield put({
            type: serviceCaseActionTypes.STORE_SERVICE_CASE_SEARCH_RESULTS,
            payload: {
                serviceCaseDTOs: [],
                totalCount: 0,
                persistenceState: persistenceStates.READY,
                isError: true,
            },
        });
    }

    // reset tasks results - fix for ACEDEV-809
    yield put({
        type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
        payload: {
            taskDTOs: [],
            taskSearchResultsCount: 0,
        },
    });
    yield put({type: taskActionTypes.RESET_TASK_COUNT_INDICATOR});

    window.sessionStorage.setItem('serviceCaseOriginQueryParams', searchQueryParams.toString());
};

export default searchServiceCases;
